import styled, { keyframes } from 'styled-components'

const SLIDE_DURATION_MS = 350

const enterFromRight = keyframes`
  from { transform: translateX(100%); opacity: 0; }
  to { transform: translateX(0); opacity: 1; }
`

const enterFromLeft = keyframes`
  from { transform: translateX(-100%); opacity: 0; }
  to { transform: translateX(0); opacity: 1; }
`

const leaveToLeft = keyframes`
  from { transform: translateX(0); opacity: 1; }
  to { transform: translateX(-100%); opacity: 0; }
`

const leaveToRight = keyframes`
  from { transform: translateX(0); opacity: 1; }
  to { transform: translateX(100%); opacity: 0; }
`

export default styled.div`
  display: grid;
  width: 100%;

  &.sliding {
    overflow: hidden;
  }

  .slide-panel {
    grid-area: 1 / 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-width: 0;
    outline: none;
    animation-duration: ${ SLIDE_DURATION_MS }ms;
    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    animation-fill-mode: both;
  }

  .slide-panel.enter-forward {
    animation-name: ${ enterFromRight };
  }

  .slide-panel.enter-back {
    animation-name: ${ enterFromLeft };
  }

  .slide-panel.leave-forward {
    animation-name: ${ leaveToLeft };
    pointer-events: none;
  }

  .slide-panel.leave-back {
    animation-name: ${ leaveToRight };
    pointer-events: none;
  }
`
